import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20.204 11.457V5.55c0-.168 0-.252-.056-.405a1.365 1.365 0 00-.233-.358c-.118-.113-.159-.13-.24-.167-.615-.27-1.85-.62-4.132-.62-3.728 0-6.524 1.864-9.32 1.864-.892 0-1.688-.095-2.36-.224-.96-.184-1.44-.276-1.678-.193a.812.812 0 00-.495.41c-.127.217-.127.641-.127 1.488v10.018c0 .168 0 .252.055.405.033.092.162.29.233.358.118.113.159.13.24.167.615.27 1.85.62 4.132.62 3.728 0 4.164-1.369 6.96-1.369.892 0 1.689.095 2.36.224m-2.33-6.312a2.33 2.33 0 11-4.66 0 2.33 2.33 0 014.66 0zM5.29 9.592v3.728m11.186-3.728v3.728"
    }),
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18.34 14.253l4.66 4.66m0-4.66l-4.66 4.66"
    })
  ]))
}